import { memo, useEffect } from 'react';

// Components
import Header from '../Navegacion/Header';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMe } from '../../features/auth/authSlice';
import { Box } from '@chakra-ui/react';

const Layout = memo(({ children }) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { isError } = useSelector(state => state.auth);

	useEffect(() => {
		dispatch(getMe());
	}, [dispatch]);

	useEffect(() => {
		isError && navigate('/');
	}, [isError, navigate]);

	return (
		<Box minH='100vh'>
			<Header />
			<Box
				p={{ base: 4, md: 6, lg: 8 }}
				mt={{ base: 2, md: 4 }}
				maxW='100vw'
				overflowX='hidden'
			>
				{children}
			</Box>
		</Box>
	);
});

export default Layout;
